/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { ErrorType } from '../../../../shared/api/custom-instance';

import { customInstance } from '../../../../shared/api/custom-instance';
import type { ReferenceChatAvailabilitiesResponse } from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * ログインユーザーのテナントの都道府県に基づいて、
各リファレンスチャットタイプの利用可否を返却します。

 * @summary リファレンスチャット利用可否取得
 */
export const getReferenceChatAvailabilities = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ReferenceChatAvailabilitiesResponse>(
    { url: `/references/availabilities`, method: 'GET', signal },
    options,
  );
};

export const getGetReferenceChatAvailabilitiesQueryKey = () => {
  return [`/references/availabilities`] as const;
};

export const getGetReferenceChatAvailabilitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReferenceChatAvailabilitiesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>> = ({
    signal,
  }) => getReferenceChatAvailabilities(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReferenceChatAvailabilitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReferenceChatAvailabilities>>
>;
export type GetReferenceChatAvailabilitiesQueryError = ErrorType<void>;

export function useGetReferenceChatAvailabilities<
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
          TError,
          Awaited<ReturnType<typeof getReferenceChatAvailabilities>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReferenceChatAvailabilities<
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
          TError,
          Awaited<ReturnType<typeof getReferenceChatAvailabilities>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReferenceChatAvailabilities<
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary リファレンスチャット利用可否取得
 */

export function useGetReferenceChatAvailabilities<
  TData = Awaited<ReturnType<typeof getReferenceChatAvailabilities>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReferenceChatAvailabilities>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReferenceChatAvailabilitiesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
